/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Acceptance_TitleInputs */

const es_tyc_acceptance_title = /** @type {(inputs: Tyc_Acceptance_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Aceptacion de los Terminos`)
};

const en_tyc_acceptance_title = /** @type {(inputs: Tyc_Acceptance_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Acceptance of Terms`)
};

/**
* | output |
* | --- |
* | "1. Acceptance of Terms" |
*
* @param {Tyc_Acceptance_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_acceptance_title = /** @type {((inputs?: Tyc_Acceptance_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Acceptance_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_acceptance_title(inputs)
	return en_tyc_acceptance_title(inputs)
});
export { tyc_acceptance_title as "tyc.acceptance.title" }